import { render, staticRenderFns } from "./dgsaList.vue?vue&type=template&id=747867c4&scoped=true"
import script from "./dgsaList.vue?vue&type=script&lang=js"
export * from "./dgsaList.vue?vue&type=script&lang=js"
import style0 from "./dgsaList.vue?vue&type=style&index=0&id=747867c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747867c4",
  null
  
)

export default component.exports